import { format } from 'date-fns';

export const slashFormat = (date: Date): string => format(date, 'yyyy/MM/dd');
export const dotFormat = (date: Date): string => format(date, 'dd.MM.yyyy');
export const shortDotFormat = (date: Date): string => format(date, 'd.M.yyyy');
export const isoFormat = (date: Date): string => format(date, 'yyyy-MM-dd');
export const isoUTCFormat = (date: Date): string => {
  return date.toISOString().split('T')[0];
};
